export const PERIODS = [
  { id: '5y', label: '5 god', long: '5 godina', months: 60 },
  { id: '3y', label: '3 god', long: '3 godine', months: 36 },
  { id: '2y', label: '2 god', long: '2 godine', months: 24 },
  { id: '1y', label: '1 god', long: '1 godina', months: 12 },
  { id: '6m', label: '6 mj', long: '6 mjeseci', months: 6 },
  { id: '3m', label: '3 mj', long: '3 mjeseca', months: 3 },
  { id: '1m', label: '1 mj', long: '1 mjesec', months: 1 },
  { id: 'ytd', label: 'Do sada ove godine', long: 'od početka godine' },
];
const DAY = 86400000;
export function boundary(date, period) {
  const d = new Date(date + 'T12:00:00Z');
  if (!Number.isFinite(+d)) return null;
  if (period === 'ytd') return `${d.getUTCFullYear() - 1}-12-31`;
  const months = PERIODS.find(p => p.id === period)?.months;
  if (!months) return null;
  const day = d.getUTCDate();
  d.setUTCDate(1); d.setUTCMonth(d.getUTCMonth() - months);
  const maxDay = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate();
  d.setUTCDate(Math.min(day, maxDay));
  return d.toISOString().slice(0, 10);
}
export function cleanHistory(points) {
  return [...new Map(points.filter(p => /^\d{4}-\d{2}-\d{2}$/.test(p.date) && Number.isFinite(Date.parse(p.date)) && new Date(p.date).toISOString().slice(0,10) === p.date && Number.isFinite(p.value) && p.value > 0).map(p => [p.date, p])).values()].sort((a,b) => a.date.localeCompare(b.date));
}
function before(points, date) {
  let lo = 0, hi = points.length - 1, answer = -1;
  while (lo <= hi) { const mid = (lo + hi) >> 1; if (points[mid].date <= date) { answer = mid; lo = mid + 1; } else hi = mid - 1; }
  return answer;
}
export function performance(fund, period, asOf) {
  const history = fund.history || [];
  if (!history.length || !asOf) return { value: null, points: [], reason: 'Povijest cijena još nije dostupna.' };
  const start = boundary(asOf, period), endIndex = before(history, asOf), startIndex = before(history, start);
  if (!start) return { value: null, points: [], reason: 'Odaberite podržano razdoblje.' };
  const points = history.slice(Math.max(0, startIndex), endIndex + 1);
  if (fund.historyQuality !== 'full') return { value: null, points, reason: 'Potpuna povijest cijena još se provjerava.' };
  if (startIndex < 0 || endIndex < 0 || startIndex >= endIndex) return { value: null, points, reason: `Nema dovoljno povijesti za ${PERIODS.find(p => p.id === period)?.long}.` };
  const first = history[startIndex], last = history[endIndex];
  if ((Date.parse(asOf) - Date.parse(last.date)) / DAY > 7 || (Date.parse(start) - Date.parse(first.date)) / DAY > 7) return { value: null, points, reason: 'Nedostaje cijena blizu granice razdoblja.' };
  if (fund.returnStatus === 'unverified') return { value: null, points, reason: 'Provjeravamo isplate i usporedivost prinosa ove klase.' };
  return { value: (last.value / first.value - 1) * 100, points, start: first.date, end: last.date, first: first.value, last: last.value, reason: null };
}
export function rankFunds(funds, period, asOf) {
  return funds.map(fund => ({ fund, result: performance(fund, period, asOf) })).sort((a,b) => (b.result.value ?? -Infinity) - (a.result.value ?? -Infinity) || a.fund.name.localeCompare(b.fund.name, 'hr'));
}
export function annualReturns(fund, asOf) {
  const year = Number(asOf?.slice(0,4)); if (!year) return [];
  return Array.from({ length: 6 }, (_,i) => { const y = year - i, result=performance(fund, 'ytd', i === 0 ? asOf : `${y}-12-31`); return { year: y, current: i === 0, ...result, ...(fund.unverifiedAnnualReturns?.includes(y)?{value:null,reason:'Godišnji rezultat se razlikuje od objave upravitelja i još se provjerava.'}:{}) }; });
}
export function cagr(result) {
  if (result.value === null || !result.start || !result.end) return null;
  const years = (Date.parse(result.end) - Date.parse(result.start)) / DAY / 365.2425;
  return years >= 1 ? (Math.pow(result.last / result.first, 1 / years) - 1) * 100 : null;
}
export function maxDrawdown(points) {
  if (points.length < 2) return null;
  let peak = points[0], worst = null;
  for (const p of points) {
    if (p.value > peak.value) peak = p;
    const value = (p.value / peak.value - 1) * 100;
    if (!worst || value < worst.value) worst = { value, peak, trough: p };
  }
  if (!worst || worst.value === 0) return null;
  const recovery = points.find(p => p.date > worst.trough.date && p.value >= worst.peak.value);
  return { ...worst, recovered: recovery?.date || null };
}
export function samplePoints(points, max = 100) {
  if (points.length <= max) return points;
  return Array.from({ length: max }, (_,i) => points[Math.round(i * (points.length - 1) / (max - 1))]);
}
